export default 'https://tme.understood.org/assets/Light_Texture01.ddbb93a5.jpg'